// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".forgot-password-btn span{font-size:.875rem}.btn-disabled:disabled,.btn-disabled:disabled:hover{--text-opacity:1;color:#cbd5e0;color:rgba(203,213,224,var(--text-opacity));cursor:not-allowed}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
